module.exports = __webpack_public_path__ + "static/media/event4.53738e2e.jpeg";